<template>
  <div class="w-100">
    <h5 class="text-center mt-3">Booking coincidente</h5>
    <div class="d-flex flex-column p-3">
      <!-- Botones -->
      <div class="d-flex flex-row flex-wrap justify-content-end mb-2">
        <!-- Data Table -->
        <data-table
          :headers="headers"
          :data="dataResultadoBooking"
          :acciones="acciones"
          idtabla="buscar_bl_tabla_resultado"
        />
      </div>
    </div>
  </div>
</template>

<script>
// Componentes
import DataTable from "../../../components/common/DataTable";
import { mapState } from "vuex";

export default {
  data() {
    return {
      // Estructura para utilizar dataTable vue
      headers: [
        "ID",
        "Cliente",
        "POL",
        "POD",
        "Semana",
        "Naviera",
        "Número de Booking",
        "Total Contenedores Embarcados"
      ],
      acciones: [],
    };
  },
  components: {
    DataTable,
  },
  computed:{
    ...mapState('lineas', ["dataResultadoBooking"]),
  },
};
</script>

<style>
.ui-modal--size-large > .ui-modal__wrapper > .ui-modal__container {
  width: 70rem;
}
</style>
